import React from 'react';
import {Helmet} from "react-helmet";
import OffWrap from '../../components/Layout/Header/OffWrap';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import Newsletter from '../../components/Common/Newsletter';
import HomeMain from './HomeMain';

import footerLogo from '../../assets/img/logo/lite-logo.png';

const HomePage = () =>  {
    return (
        <React.Fragment>
            <Helmet>
              <title>"Школа Іноземних Мов Wonderland: ми відповідаємо за тих, кого навчаємо"</title>
              <meta name="description" content="Приєднуйтеся до Школи Іноземних Мов Wonderland і навчайтеся іноземним мовам з нами. Ми пропонуємо широкий вибір курсів іноземних мов, що допоможуть вам розвивати свої навички у вивченні іноземних мов. З нами ви зможете швидко і зручно навчитися іноземній мові, що відкриє для вас нові можливості у житті і кар'єрі. Зареєструйтеся зараз і розпочніть свій шлях до володіння іноземною мовою з нами!" />
              <meta property="og:title" content="Школа Іноземних Мов Wonderland: ми відповідаємо за тих, кого навчаємо" />
              <meta property="og:image" content="/preview.jpg" />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu='головна'
            />
            <HomeMain />
            {/* <Newsletter
                sectionClass="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-70"
                titleClass="title mb-0 white-color"
            /> */}
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
        </React.Fragment>
    );
}

export default HomePage;
